import React, { useEffect, useMemo, useState } from "react";
import sahabatKakaoImg from "../assets/Sahabatkakao.png";
import "./KisahSukses.css";

const API = process.env.REACT_APP_API_URL || "/api";

const fallbackStories = [
  {
    id: "fallback",
    name: "Perjalanan Petani Kakao Berdaya",
    address: "Sahabat Kakao Indonesia",
    business_type: "Budidaya Kakao",
    short_story:
      "Cerita perubahan dari kebun kakao: belajar praktik budidaya, memperbaiki kualitas panen, dan membangun usaha yang lebih kuat bersama komunitas.",
    video_url: "/videos/kisah-sukses-petani.mp4",
    poster: sahabatKakaoImg,
  },
];

function getEmbedUrl(url) {
  try {
    const parsed = new URL(url);
    if (parsed.hostname.includes("youtube.com")) {
      const shortsMatch = parsed.pathname.match(/^\/shorts\/([^/?]+)/);
      if (shortsMatch?.[1]) return getYoutubeEmbedUrl(shortsMatch[1]);
      const id = parsed.searchParams.get("v");
      return id ? getYoutubeEmbedUrl(id) : "";
    }
    if (parsed.hostname.includes("youtu.be")) {
      const id = parsed.pathname.replace("/", "");
      return id ? getYoutubeEmbedUrl(id) : "";
    }
    if (parsed.hostname.includes("vimeo.com")) {
      const id = parsed.pathname.split("/").filter(Boolean).pop();
      return id ? `https://player.vimeo.com/video/${id}` : "";
    }
    if (parsed.hostname.includes("drive.google.com")) {
      const match = parsed.pathname.match(/\/file\/d\/([^/]+)/);
      return match?.[1] ? `https://drive.google.com/file/d/${match[1]}/preview` : url;
    }
    return url;
  } catch {}
  return "";
}

function getYoutubeEmbedUrl(id) {
  const params = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    showinfo: "0",
    iv_load_policy: "3",
    playsinline: "1",
  });
  return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
}

function isDirectVideo(url) {
  return /\.(mp4|webm|ogg)(\?.*)?$/i.test(String(url || ""));
}

export default function KisahSukses() {
  const [stories, setStories] = useState(fallbackStories);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/success-stories/public`)
      .then((res) => res.json())
      .then((json) => {
        if (!alive) return;
        const rows = Array.isArray(json?.data) ? json.data : [];
        setStories(rows.length ? rows : fallbackStories);
      })
      .catch(() => {
        if (alive) setStories(fallbackStories);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="success-page">
      <section className="success-hero">
        <div className="success-copy">
          <h1>Inspirasi dari petani serta pelaku usaha pertanian dan kakao yang terus bertumbuh.</h1>
          <p>
            Saksikan cerita nyata bagaimana pengetahuan, layanan, dan ekosistem
            Sahabat Kakao membantu membuka peluang baru di kebun dan usaha pertanian kakao.
          </p>
        </div>
      </section>

      <section className="success-content" aria-label="Daftar video kisah sukses">
        {stories.map((story) => (
          <SuccessStoryCard story={story} key={story.id || story.video_url} />
        ))}
      </section>
    </div>
  );
}

function SuccessStoryCard({ story }) {
  const embedUrl = useMemo(() => getEmbedUrl(story.video_url), [story.video_url]);
  const directVideo = isDirectVideo(story.video_url);

  return (
    <article className="success-video-card">
      <div className="success-video-wrap">
        {directVideo ? (
          <video controls preload="metadata" poster={story.poster || sahabatKakaoImg}>
            <source src={story.video_url} />
            Browser Anda belum mendukung pemutar video.
          </video>
        ) : embedUrl ? (
          <>
          <iframe
            src={embedUrl}
            title={story.name}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
          </>
        ) : (
          <div className="success-video-empty">Video belum tersedia.</div>
        )}
      </div>

      <div className="success-video-info">
        <h2>{story.name}</h2>
        <p className="success-location">{story.address}</p>
        <p className="success-business">{story.business_type}</p>
        <p className="success-short-story">{story.short_story}</p>
      </div>
    </article>
  );
}
